export interface ConsumerCartServiceConfig {
	baseUrl: string;
}

/**
 * Loads the consumer cart service configuration from environment variables.
 *
 * @return the loaded ConsumerCartServiceConfig object.
 * @throws IllegalStateException if the consumer cart service config is not set.
 */
export function loadConsumerCartServiceConfig(): ConsumerCartServiceConfig {
	const { CONSUMER_CART_SERVICE } = process.env;

	if (!CONSUMER_CART_SERVICE) {
		throw new Error("CONSUMER_CART_SERVICE config is not set.");
	}

	return {
		baseUrl: CONSUMER_CART_SERVICE
	};
}
